import { IconProps } from '@tabler/icons-react-native'
import { Path, Svg } from 'react-native-svg'

export default function EyeClosed({
  size = 24,
  strokeWidth = 2,
  color = 'black',
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M21 12C18.5078 16.2002 15.6 18 12 18C8.4 18 5.5 16.2002 3 12M3 20.0002L5.5 16.2002M20.9998 19.9762L18.5078 16.2002M9 22L9.5 18M15 22L14.5 18"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
